import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import RCore from 'RCore';
import _ from 'lodash';
import { styledUI } from '../../StyledUI';

//These lines are needed to get common i18
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const Container = styled.div``;

const LIList = styled.li`
    position: relative;
    display: flex;
    padding: 10px 20px;
    line-height: 20px;
    align-items: center;
    z-index: 2;
    margin-bottom: 4px;
    color: ${props => props.theme.color};
    &:last-child {
        margin-bottom: 0;
    }

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        content: ' ';
        background-color: ${props => props.theme.content.backgroundColor};
        z-index: 0;
    }
    & > * {
        z-index: 2;
    }
    .tl-title {
        font-size: 18px !important;
        font-weight: normal !important;
        text-transform: uppercase;
        flex-grow: 1;
    }

    .tl-image {
        margin: 0 20px;
        width: 60px;
    }
    .list-player-name {
        font-size: 24px;
        line-height: 26px;
        text-transform: uppercase;
        flex-grow: 1;
        overflow: hidden;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        z-index: 3;
    }
    .tl-score {
        text-align: right;
        font-size: 48px;
        margin-left: 10px;
        white-space: nowrap;
        position: relative;
        z-index: 3;
        color: ${props => props.theme.content.accentColor};
    }
    .tl-unit {
        font-size: 22px;
    }

    &.pls_highlight {
        background-color: ${props => props.theme.content.accentColor};
    }
`;

const Header = ({ valueTitle }, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');

    return (
        <LIList>
            <div className="tl-image" />
            <div className="list-player-name tl-title">{i18('name', lang)}</div>
            <div className="tl-score  tl-title">{valueTitle}</div>
        </LIList>
    );
};

const PlayerLogo = withTheme(({ theme, player, seasonId, ...props }) => {
    const SMPlayerLogo = styledUI.getCustomComponentFromTheme(theme, 'playerLogo', props);

    return (
        <div style={{ position: 'relative' }}>
            <SMPlayerLogo
                playerId={player.id}
                teamId={player.teamId}
                seasonId={seasonId}
                width={60}
                height={60}
                number={player.shirtNumber}
            />
        </div>
    );
});

const Row = withTheme(({ player, seasonId, highlightFirstPlayer, highlightTeam, ...props }) => {
    var name = RCore.getFirstLastName(player.name);

    return (
        <LIList
            key={player.id}
            className={highlightFirstPlayer || highlightTeam === player.teamId ? 'pls_highlight' : ''}
        >
            <div className="tl-image">
                <PlayerLogo player={player} seasonId={seasonId} playerLogoDisplay={props.playerLogoDisplay} />
            </div>
            <div className="list-player-name">
                {name.firstName} <b>{name.lastName}</b>
            </div>
            <div className="tl-score __c__c1_style1">{player.displayValue || player.value}</div>
        </LIList>
    );
});

Header.contextTypes = {
    info: PropTypes.object
};

Row.contextTypes = {
    info: PropTypes.object
};

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/lists/PlayersListSimple.js
 **/